(() => {
  const MOBILE = window.matchMedia('(max-width: 767.98px)');

  function mediaItems(viewer) {
    return Array.from(viewer.children).filter((el) => el.nodeType === 1);
  }

  function getPreviewImage(item) {
    return item.querySelector('img');
  }

  function setActive(thumbs, index) {
    thumbs.forEach((thumb, i) => {
      const active = i === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    // IMPORTANT: Do not use Element.scrollIntoView() here. On mobile browsers it can
    // move the whole page vertically when the active product image changes, which was
    // causing the product page to feel stuck / jump back down while the user scrolls up.
    // Only scroll the thumbnail strip horizontally when the active thumb is clipped.
    const activeThumb = thumbs[index];
    const nav = activeThumb && activeThumb.parentElement;
    if (activeThumb && nav && MOBILE.matches) {
      const left = activeThumb.offsetLeft;
      const right = left + activeThumb.offsetWidth;
      const visibleLeft = nav.scrollLeft;
      const visibleRight = visibleLeft + nav.clientWidth;
      let target = null;

      if (left < visibleLeft + 4) {
        target = Math.max(0, left - 8);
      } else if (right > visibleRight - 4) {
        target = Math.max(0, right - nav.clientWidth + 8);
      }

      if (target !== null && Math.abs(nav.scrollLeft - target) > 2) {
        nav.scrollTo({ left: target, behavior: 'smooth' });
      }
    }
  }

  function buildThumbs(gallery) {
    if (!gallery || gallery.dataset.layout !== 'grid') return;
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;

    gallery.querySelectorAll('.veroconic-mobile-media-dots, .veroconic-mobile-media-thumbs').forEach((el) => el.remove());

    const items = mediaItems(viewer);
    if (items.length <= 1) return;

    const nav = document.createElement('div');
    nav.className = 'veroconic-mobile-media-thumbs';
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', 'Product image thumbnails');

    const thumbs = items.map((item, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'veroconic-mobile-media-thumb';
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-label', `View product image ${index + 1}`);

      const source = getPreviewImage(item);
      if (source) {
        const img = document.createElement('img');
        img.alt = source.alt || `Product image ${index + 1}`;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.src = source.currentSrc || source.src;
        if (source.srcset) img.srcset = source.srcset;
        if (source.sizes) img.sizes = '58px';
        button.appendChild(img);
      } else {
        button.textContent = String(index + 1);
      }

      button.addEventListener('click', () => {
        viewer.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        setActive(thumbs, index);
      });

      nav.appendChild(button);
      return button;
    });

    gallery.appendChild(nav);
    setActive(thumbs, 0);

    let raf = null;
    const update = () => {
      if (!MOBILE.matches) return;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const viewerLeft = viewer.getBoundingClientRect().left;
        let bestIndex = 0;
        let bestDistance = Infinity;
        items.forEach((item, index) => {
          const distance = Math.abs(item.getBoundingClientRect().left - viewerLeft);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = index;
          }
        });
        setActive(thumbs, bestIndex);
      });
    };

    viewer.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  function init(scope = document) {
    scope.querySelectorAll('media-gallery[data-layout="grid"]').forEach(buildThumbs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((m) => m.type === 'childList' && m.addedNodes.length)) {
      clearTimeout(window.__veroconicGalleryThumbsTimer);
      window.__veroconicGalleryThumbsTimer = setTimeout(() => init(), 160);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
